import {Action} from '@ngrx/store';
import {GetOrganizationTokenRequest, GetOrganizationTokensRequest, TokenWithId} from '../models/token';
import {ErrorPayload} from '../models/general';

export enum OrganizationTokenActionTypes {
  GetOrganizationToken = '[OrganizationToken] Get Organization Token',
  GetOrganizationTokenComplete = '[OrganizationToken] Get Organization Token Complete',
  GetOrganizationTokenError = '[OrganizationToken] Get Organization Token Error',
  GetOrganizationTokens = '[OrganizationToken] Get Organization Tokens',
  GetOrganizationTokensComplete = '[OrganizationToken] Get Organization Tokens Complete',
  GetOrganizationTokensError = '[OrganizationToken] Get Organization Tokens Error'
}

export class GetOrganizationToken implements Action {
  readonly type = OrganizationTokenActionTypes.GetOrganizationToken;

  constructor(public payload: GetOrganizationTokenRequest) {
  }
}

export class GetOrganizationTokenComplete implements Action {
  readonly type = OrganizationTokenActionTypes.GetOrganizationTokenComplete;

  constructor(public payload: TokenWithId) {
  }
}

export class GetOrganizationTokenError implements Action {
  readonly type = OrganizationTokenActionTypes.GetOrganizationTokenError;

  constructor(public payload: ErrorPayload) {
  }
}

export class GetOrganizationTokens implements Action {
  readonly type = OrganizationTokenActionTypes.GetOrganizationTokens;

  constructor(public payload: GetOrganizationTokensRequest) {
  }
}

export class GetOrganizationTokensComplete implements Action {
  readonly type = OrganizationTokenActionTypes.GetOrganizationTokensComplete;

  constructor(public payload: { [organizationId: string]: string }) {
  }
}

export class GetOrganizationTokensError implements Action {
  readonly type = OrganizationTokenActionTypes.GetOrganizationTokensError;

  constructor(public payload: ErrorPayload) {
  }
}

export type OrganizationTokenActions =
  | GetOrganizationToken
  | GetOrganizationTokenComplete
  | GetOrganizationTokenError
  | GetOrganizationTokens
  | GetOrganizationTokensComplete
  | GetOrganizationTokensError;
